import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth";
//LAYOUT COMPONENTS
import Menu from "../../components/comun/Menu/Menu";
import Footer from "../../components/Footer";
import Item from "../../components/comun/Menu/Item";
//PAGES
import Companias from "./Companias/Companias";
import Deducciones from "./Deducciones/Deducciones";
import ObrasAsignadas from "./AsignacionObras/TablaObrasAsignadas";
import RegitroObras from "./RegistroObras/TablaRegistroObras";
import FacturarTasasIngenieria from "./FacturarTasasIngenieria/FacturarTasasIngenieria";
import FacturarTasasOMPU from "./FacturarTasasOMPU/FacturarTasasIngenieria";
import TablaCaratulaContrato from "./CaratulaContrato/TablaCaratulaContrato";
import TablaSolicitudesPago from "./SolicitudPagos/TablaSolicitudesPago";
import CuadernoObras from "./CuadernoObras/CuadernoObras";
import AprobarSolicitud from "./AprobarSolicitud/AprobarSolicitud";
import Usuarios from "./Usuarios/Usuarios";
import imgIngenieria from "../../imagenes/fd_ingenieria.png";

export default function Ingenieria() {
  const op = require("../../../src/modulos/datos");

  const { user } = useContext(AuthContext);

  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [show, setShow] = useState(false);
  const [tabla, setTabla] = useState(0);

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
      setFechaSistema(obj.fechasistema);
    }
  }, []);

  const actualizacionItem = {
    title: "Actualización",
    icon: "fa fa-pen-alt me-2",
    drop: [
      {
        title: "Compañias",
        icon: "fa fa-building me-2",
        itemClickValue: 1,
      },
      {
        title: "Tipo Deducciones",
        icon: "fa fa-folder me-2",
        itemClickValue: 2,
      },
      {
        title: "Registro de Obras y Servicios",
        icon: "fa fa-address-card me-2",
        itemClickValue: 3,
      },
      {
        title: "Facturar Tasas Ingenieria",
        icon: "fa fa-money-bill me-2",
        itemClickValue: 4,
      },
      {
        title: "Facturar Tasas OMPU",
        icon: "fa fa-money-bill me-2",
        itemClickValue: 5,
      },
    ],
  };
  const registroItem = {
    title: "Registro",
    icon: "fa fa-address-book me-2",
    drop: [
      {
        title: "Asignación de Obras y Servicios",
        icon: "fa fa-address-book me-2",
        itemClickValue: 6,
      },
      {
        title: "Caratula del Contrato",
        icon: "fa fa-book me-2",
        itemClickValue: 7,
      },
      {
        title: "Cuaderno de Obras",
        icon: "fa fa-book me-2",
        itemClickValue: 8,
      },
      {
        title: "Solicitud de Pagos",
        icon: "fa fa-money-bill me-2",
        itemClickValue: 9,
      },
      {
        title: "Aprobar Solicitud de Pagos",
        icon: "fa fa-check me-2",
        itemClickValue: 10,
      },
    ],
  };
  const configuracionItem = {
    title: "Configuración",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Usuarios",
        icon: "fa fa-user me-2",
        itemClickValue: 11,
      },
    ],
  };

  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgIngenieria}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };

  const vista = {
    0: <PorDefecto />,
    1: <Companias setTabla={setTabla} setShow={setShow} show={show} />,
    2: <Deducciones setTabla={setTabla} setShow={setShow} show={show} />,
    3: <RegitroObras setTabla={setTabla} setShow={setShow} show={show} />,
    4: <FacturarTasasIngenieria setTabla={setTabla} />,
    5: <FacturarTasasOMPU setTabla={setTabla} />,
    6: <ObrasAsignadas setTabla={setTabla} setShow={setShow} show={show} />,
    7: (
      <TablaCaratulaContrato
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    8: <CuadernoObras setTabla={setTabla} setShow={setShow} show={show} />,
    9: (
      <TablaSolicitudesPago setTabla={setTabla} setShow={setShow} show={show} />
    ),
    10: <AprobarSolicitud setTabla={setTabla} />,
    11: <Usuarios setTabla={setTabla} />,
  };

  if (!user) return <></>;

  return (
    <div className="w-100 col-12 m-0 p-0">
      <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
        <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
        <Item item={registroItem} setTabla={setTabla} setShow={setShow} />
        <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />
        <a
          href="/inicio"
          className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
        >
          <i className="fas fa-power-off me-2" />
          Salir
        </a>
      </Menu>
      <section
        className="w-100 col-12 m-0 p-0 d-flex align-items-center justify-content-center"
        style={{ height: "90dvh" }}
      >
        {vista[tabla]}
      </section>
      <Footer />
    </div>
  );
}
